/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminEbayAccountResp,
    AdminEbayAccountRespFromJSON,
    AdminEbayAccountRespToJSON,
    AdminEbayCategoryResp,
    AdminEbayCategoryRespFromJSON,
    AdminEbayCategoryRespToJSON,
    AdminEbayCategorySuggestionsResp,
    AdminEbayCategorySuggestionsRespFromJSON,
    AdminEbayCategorySuggestionsRespToJSON,
    AdminEbayConnectReq,
    AdminEbayConnectReqFromJSON,
    AdminEbayConnectReqToJSON,
    AdminEbayConnectUrlResp,
    AdminEbayConnectUrlRespFromJSON,
    AdminEbayConnectUrlRespToJSON,
    AdminEbayDraftReq,
    AdminEbayDraftReqFromJSON,
    AdminEbayDraftReqToJSON,
    AdminEbayListing,
    AdminEbayListingFromJSON,
    AdminEbayListingToJSON,
    AdminEbaySellingLimitResp,
    AdminEbaySellingLimitRespFromJSON,
    AdminEbaySellingLimitRespToJSON,
    AdminEbaySetupReq,
    AdminEbaySetupReqFromJSON,
    AdminEbaySetupReqToJSON,
} from '../models';

import {
    AdminEbayApi,
    AdminEbayApiAdminEbayCategorySuggestionsRequest,
    AdminEbayApiAdminEbayConnectRequest,
    AdminEbayApiAdminEbayDeleteDraftRequest,
    AdminEbayApiAdminEbayEndRequest,
    AdminEbayApiAdminEbayListingRequest,
    AdminEbayApiAdminEbayProductCategoryRequest,
    AdminEbayApiAdminEbayPublishRequest,
    AdminEbayApiAdminEbaySaveDraftRequest,
    AdminEbayApiAdminEbaySetupRequest,
} from './AdminEbayApi';

type AdminEbayAccountQueryOptions = UseQueryOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayAccountResp,
    ['adminEbayAccount']
>;

let useAdminEbayAccountQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminEbayAccountQueryOptions) => AdminEbayAccountQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayAccountQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayAccountQueryOptions
    ) => AdminEbayAccountQueryOptions | undefined
) {
    useAdminEbayAccountQueryGlobalOptions = callback;
}

export function getAdminEbayAccountQueryKey(): ['adminEbayAccount'] {
    return ['adminEbayAccount'];
}

export function useAdminEbayAccountQuery(
    options?: AdminEbayAccountQueryOptions
): UseQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayAccountQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayAccount({signal})),
        {
            ...options,
            ...useAdminEbayAccountQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminEbayAccountMutationOptions = UseMutationOptions<AdminEbayAccountResp, Array<Error>>;

let useAdminEbayAccountMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayAccountMutationOptions
      ) => AdminEbayAccountMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayAccountMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayAccountMutationOptions
    ) => AdminEbayAccountMutationOptions | undefined
) {
    useAdminEbayAccountMutationGlobalOptions = callback;
}

export function useAdminEbayAccountMutation(
    options?: AdminEbayAccountMutationOptions
): UseMutationResult<AdminEbayAccountResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayAccount()),
        {
            ...options,
            ...useAdminEbayAccountMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayAccountInfiniteQueryKey(): ['adminEbayAccount-infinite'] {
    return ['adminEbayAccount-infinite'];
}

export function useAdminEbayAccountInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayAccountResp,
            Array<runtime.ApiError>,
            AdminEbayAccountResp,
            AdminEbayAccountResp,
            ['adminEbayAccount-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayAccountInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayAccount()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayCategorySuggestionsQueryOptions = UseQueryOptions<
    AdminEbayCategorySuggestionsResp,
    Array<Error>,
    AdminEbayCategorySuggestionsResp,
    ['adminEbayCategorySuggestions', AdminEbayApiAdminEbayCategorySuggestionsRequest]
>;

let useAdminEbayCategorySuggestionsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayCategorySuggestionsRequest,
          options?: AdminEbayCategorySuggestionsQueryOptions
      ) => AdminEbayCategorySuggestionsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayCategorySuggestionsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayCategorySuggestionsRequest,
        options?: AdminEbayCategorySuggestionsQueryOptions
    ) => AdminEbayCategorySuggestionsQueryOptions | undefined
) {
    useAdminEbayCategorySuggestionsQueryGlobalOptions = callback;
}

export function getAdminEbayCategorySuggestionsQueryKey(
    params: AdminEbayApiAdminEbayCategorySuggestionsRequest
): ['adminEbayCategorySuggestions', AdminEbayApiAdminEbayCategorySuggestionsRequest] {
    return ['adminEbayCategorySuggestions', params];
}

export function useAdminEbayCategorySuggestionsQuery(
    params: AdminEbayApiAdminEbayCategorySuggestionsRequest,
    options?: AdminEbayCategorySuggestionsQueryOptions
): UseQueryResult<AdminEbayCategorySuggestionsResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayCategorySuggestionsQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayCategorySuggestions(params, {signal})
            ),
        {
            ...options,
            ...useAdminEbayCategorySuggestionsQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayCategorySuggestionsMutationOptions = UseMutationOptions<
    AdminEbayCategorySuggestionsResp,
    Array<Error>,
    AdminEbayApiAdminEbayCategorySuggestionsRequest
>;

let useAdminEbayCategorySuggestionsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayCategorySuggestionsMutationOptions
      ) => AdminEbayCategorySuggestionsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayCategorySuggestionsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayCategorySuggestionsMutationOptions
    ) => AdminEbayCategorySuggestionsMutationOptions | undefined
) {
    useAdminEbayCategorySuggestionsMutationGlobalOptions = callback;
}

export function useAdminEbayCategorySuggestionsMutation(
    options?: AdminEbayCategorySuggestionsMutationOptions
): UseMutationResult<
    AdminEbayCategorySuggestionsResp,
    Array<runtime.ApiError>,
    AdminEbayApiAdminEbayCategorySuggestionsRequest
> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayCategorySuggestions(params)),
        {
            ...options,
            ...useAdminEbayCategorySuggestionsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayCategorySuggestionsInfiniteQueryKey(
    params: AdminEbayApiAdminEbayCategorySuggestionsRequest
): ['adminEbayCategorySuggestions-infinite', AdminEbayApiAdminEbayCategorySuggestionsRequest] {
    return ['adminEbayCategorySuggestions-infinite', params];
}

export function useAdminEbayCategorySuggestionsInfiniteQuery(
    params: AdminEbayApiAdminEbayCategorySuggestionsRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayCategorySuggestionsResp,
            Array<runtime.ApiError>,
            AdminEbayCategorySuggestionsResp,
            AdminEbayCategorySuggestionsResp,
            ['adminEbayCategorySuggestions-infinite', AdminEbayApiAdminEbayCategorySuggestionsRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayCategorySuggestionsResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayCategorySuggestionsInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayCategorySuggestions({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayConnectQueryOptions = UseQueryOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayAccountResp,
    ['adminEbayConnect', AdminEbayApiAdminEbayConnectRequest]
>;

let useAdminEbayConnectQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayConnectRequest,
          options?: AdminEbayConnectQueryOptions
      ) => AdminEbayConnectQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayConnectQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayConnectRequest,
        options?: AdminEbayConnectQueryOptions
    ) => AdminEbayConnectQueryOptions | undefined
) {
    useAdminEbayConnectQueryGlobalOptions = callback;
}

export function getAdminEbayConnectQueryKey(
    params: AdminEbayApiAdminEbayConnectRequest
): ['adminEbayConnect', AdminEbayApiAdminEbayConnectRequest] {
    return ['adminEbayConnect', params];
}

export function useAdminEbayConnectQuery(
    params: AdminEbayApiAdminEbayConnectRequest,
    options?: AdminEbayConnectQueryOptions
): UseQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayConnectQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayConnect(params, {signal})),
        {
            ...options,
            ...useAdminEbayConnectQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayConnectMutationOptions = UseMutationOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayApiAdminEbayConnectRequest
>;

let useAdminEbayConnectMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayConnectMutationOptions
      ) => AdminEbayConnectMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayConnectMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayConnectMutationOptions
    ) => AdminEbayConnectMutationOptions | undefined
) {
    useAdminEbayConnectMutationGlobalOptions = callback;
}

export function useAdminEbayConnectMutation(
    options?: AdminEbayConnectMutationOptions
): UseMutationResult<AdminEbayAccountResp, Array<runtime.ApiError>, AdminEbayApiAdminEbayConnectRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayConnect(params)),
        {
            ...options,
            ...useAdminEbayConnectMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayConnectInfiniteQueryKey(
    params: AdminEbayApiAdminEbayConnectRequest
): ['adminEbayConnect-infinite', AdminEbayApiAdminEbayConnectRequest] {
    return ['adminEbayConnect-infinite', params];
}

export function useAdminEbayConnectInfiniteQuery(
    params: AdminEbayApiAdminEbayConnectRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayAccountResp,
            Array<runtime.ApiError>,
            AdminEbayAccountResp,
            AdminEbayAccountResp,
            ['adminEbayConnect-infinite', AdminEbayApiAdminEbayConnectRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayConnectInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayConnect({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayConnectUrlQueryOptions = UseQueryOptions<
    AdminEbayConnectUrlResp,
    Array<Error>,
    AdminEbayConnectUrlResp,
    ['adminEbayConnectUrl']
>;

let useAdminEbayConnectUrlQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayConnectUrlQueryOptions
      ) => AdminEbayConnectUrlQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayConnectUrlQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayConnectUrlQueryOptions
    ) => AdminEbayConnectUrlQueryOptions | undefined
) {
    useAdminEbayConnectUrlQueryGlobalOptions = callback;
}

export function getAdminEbayConnectUrlQueryKey(): ['adminEbayConnectUrl'] {
    return ['adminEbayConnectUrl'];
}

export function useAdminEbayConnectUrlQuery(
    options?: AdminEbayConnectUrlQueryOptions
): UseQueryResult<AdminEbayConnectUrlResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayConnectUrlQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayConnectUrl({signal})),
        {
            ...options,
            ...useAdminEbayConnectUrlQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminEbayConnectUrlMutationOptions = UseMutationOptions<AdminEbayConnectUrlResp, Array<Error>>;

let useAdminEbayConnectUrlMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayConnectUrlMutationOptions
      ) => AdminEbayConnectUrlMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayConnectUrlMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayConnectUrlMutationOptions
    ) => AdminEbayConnectUrlMutationOptions | undefined
) {
    useAdminEbayConnectUrlMutationGlobalOptions = callback;
}

export function useAdminEbayConnectUrlMutation(
    options?: AdminEbayConnectUrlMutationOptions
): UseMutationResult<AdminEbayConnectUrlResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayConnectUrl()),
        {
            ...options,
            ...useAdminEbayConnectUrlMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayConnectUrlInfiniteQueryKey(): ['adminEbayConnectUrl-infinite'] {
    return ['adminEbayConnectUrl-infinite'];
}

export function useAdminEbayConnectUrlInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayConnectUrlResp,
            Array<runtime.ApiError>,
            AdminEbayConnectUrlResp,
            AdminEbayConnectUrlResp,
            ['adminEbayConnectUrl-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayConnectUrlResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayConnectUrlInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayConnectUrl()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayDeleteDraftQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminEbayDeleteDraft', AdminEbayApiAdminEbayDeleteDraftRequest]
>;

let useAdminEbayDeleteDraftQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayDeleteDraftRequest,
          options?: AdminEbayDeleteDraftQueryOptions
      ) => AdminEbayDeleteDraftQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayDeleteDraftQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayDeleteDraftRequest,
        options?: AdminEbayDeleteDraftQueryOptions
    ) => AdminEbayDeleteDraftQueryOptions | undefined
) {
    useAdminEbayDeleteDraftQueryGlobalOptions = callback;
}

export function getAdminEbayDeleteDraftQueryKey(
    params: AdminEbayApiAdminEbayDeleteDraftRequest
): ['adminEbayDeleteDraft', AdminEbayApiAdminEbayDeleteDraftRequest] {
    return ['adminEbayDeleteDraft', params];
}

export function useAdminEbayDeleteDraftQuery(
    params: AdminEbayApiAdminEbayDeleteDraftRequest,
    options?: AdminEbayDeleteDraftQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayDeleteDraftQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayDeleteDraft(params, {signal})),
        {
            ...options,
            ...useAdminEbayDeleteDraftQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayDeleteDraftMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminEbayApiAdminEbayDeleteDraftRequest
>;

let useAdminEbayDeleteDraftMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayDeleteDraftMutationOptions
      ) => AdminEbayDeleteDraftMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayDeleteDraftMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayDeleteDraftMutationOptions
    ) => AdminEbayDeleteDraftMutationOptions | undefined
) {
    useAdminEbayDeleteDraftMutationGlobalOptions = callback;
}

export function useAdminEbayDeleteDraftMutation(
    options?: AdminEbayDeleteDraftMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminEbayApiAdminEbayDeleteDraftRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayDeleteDraft(params)),
        {
            ...options,
            ...useAdminEbayDeleteDraftMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayDeleteDraftInfiniteQueryKey(
    params: AdminEbayApiAdminEbayDeleteDraftRequest
): ['adminEbayDeleteDraft-infinite', AdminEbayApiAdminEbayDeleteDraftRequest] {
    return ['adminEbayDeleteDraft-infinite', params];
}

export function useAdminEbayDeleteDraftInfiniteQuery(
    params: AdminEbayApiAdminEbayDeleteDraftRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminEbayDeleteDraft-infinite', AdminEbayApiAdminEbayDeleteDraftRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayDeleteDraftInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayDeleteDraft({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayDisconnectQueryOptions = UseQueryOptions<void, Array<Error>, void, ['adminEbayDisconnect']>;

let useAdminEbayDisconnectQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayDisconnectQueryOptions
      ) => AdminEbayDisconnectQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayDisconnectQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayDisconnectQueryOptions
    ) => AdminEbayDisconnectQueryOptions | undefined
) {
    useAdminEbayDisconnectQueryGlobalOptions = callback;
}

export function getAdminEbayDisconnectQueryKey(): ['adminEbayDisconnect'] {
    return ['adminEbayDisconnect'];
}

export function useAdminEbayDisconnectQuery(
    options?: AdminEbayDisconnectQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayDisconnectQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayDisconnect({signal})),
        {
            ...options,
            ...useAdminEbayDisconnectQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminEbayDisconnectMutationOptions = UseMutationOptions<void, Array<Error>>;

let useAdminEbayDisconnectMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayDisconnectMutationOptions
      ) => AdminEbayDisconnectMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayDisconnectMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayDisconnectMutationOptions
    ) => AdminEbayDisconnectMutationOptions | undefined
) {
    useAdminEbayDisconnectMutationGlobalOptions = callback;
}

export function useAdminEbayDisconnectMutation(
    options?: AdminEbayDisconnectMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayDisconnect()),
        {
            ...options,
            ...useAdminEbayDisconnectMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayDisconnectInfiniteQueryKey(): ['adminEbayDisconnect-infinite'] {
    return ['adminEbayDisconnect-infinite'];
}

export function useAdminEbayDisconnectInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<void, Array<runtime.ApiError>, void, void, ['adminEbayDisconnect-infinite']>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayDisconnectInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayDisconnect()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayEndQueryOptions = UseQueryOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayListing,
    ['adminEbayEnd', AdminEbayApiAdminEbayEndRequest]
>;

let useAdminEbayEndQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayEndRequest,
          options?: AdminEbayEndQueryOptions
      ) => AdminEbayEndQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayEndQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayEndRequest,
        options?: AdminEbayEndQueryOptions
    ) => AdminEbayEndQueryOptions | undefined
) {
    useAdminEbayEndQueryGlobalOptions = callback;
}

export function getAdminEbayEndQueryKey(
    params: AdminEbayApiAdminEbayEndRequest
): ['adminEbayEnd', AdminEbayApiAdminEbayEndRequest] {
    return ['adminEbayEnd', params];
}

export function useAdminEbayEndQuery(
    params: AdminEbayApiAdminEbayEndRequest,
    options?: AdminEbayEndQueryOptions
): UseQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayEndQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayEnd(params, {signal})),
        {
            ...options,
            ...useAdminEbayEndQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayEndMutationOptions = UseMutationOptions<AdminEbayListing, Array<Error>, AdminEbayApiAdminEbayEndRequest>;

let useAdminEbayEndMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminEbayEndMutationOptions) => AdminEbayEndMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayEndMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayEndMutationOptions
    ) => AdminEbayEndMutationOptions | undefined
) {
    useAdminEbayEndMutationGlobalOptions = callback;
}

export function useAdminEbayEndMutation(
    options?: AdminEbayEndMutationOptions
): UseMutationResult<AdminEbayListing, Array<runtime.ApiError>, AdminEbayApiAdminEbayEndRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayEnd(params)),
        {
            ...options,
            ...useAdminEbayEndMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayEndInfiniteQueryKey(
    params: AdminEbayApiAdminEbayEndRequest
): ['adminEbayEnd-infinite', AdminEbayApiAdminEbayEndRequest] {
    return ['adminEbayEnd-infinite', params];
}

export function useAdminEbayEndInfiniteQuery(
    params: AdminEbayApiAdminEbayEndRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayListing,
            Array<runtime.ApiError>,
            AdminEbayListing,
            AdminEbayListing,
            ['adminEbayEnd-infinite', AdminEbayApiAdminEbayEndRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayEndInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayEnd({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayListingQueryOptions = UseQueryOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayListing,
    ['adminEbayListing', AdminEbayApiAdminEbayListingRequest]
>;

let useAdminEbayListingQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayListingRequest,
          options?: AdminEbayListingQueryOptions
      ) => AdminEbayListingQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayListingQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayListingRequest,
        options?: AdminEbayListingQueryOptions
    ) => AdminEbayListingQueryOptions | undefined
) {
    useAdminEbayListingQueryGlobalOptions = callback;
}

export function getAdminEbayListingQueryKey(
    params: AdminEbayApiAdminEbayListingRequest
): ['adminEbayListing', AdminEbayApiAdminEbayListingRequest] {
    return ['adminEbayListing', params];
}

export function useAdminEbayListingQuery(
    params: AdminEbayApiAdminEbayListingRequest,
    options?: AdminEbayListingQueryOptions
): UseQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayListingQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayListing(params, {signal})),
        {
            ...options,
            ...useAdminEbayListingQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayListingMutationOptions = UseMutationOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayApiAdminEbayListingRequest
>;

let useAdminEbayListingMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayListingMutationOptions
      ) => AdminEbayListingMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayListingMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayListingMutationOptions
    ) => AdminEbayListingMutationOptions | undefined
) {
    useAdminEbayListingMutationGlobalOptions = callback;
}

export function useAdminEbayListingMutation(
    options?: AdminEbayListingMutationOptions
): UseMutationResult<AdminEbayListing, Array<runtime.ApiError>, AdminEbayApiAdminEbayListingRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayListing(params)),
        {
            ...options,
            ...useAdminEbayListingMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayListingInfiniteQueryKey(
    params: AdminEbayApiAdminEbayListingRequest
): ['adminEbayListing-infinite', AdminEbayApiAdminEbayListingRequest] {
    return ['adminEbayListing-infinite', params];
}

export function useAdminEbayListingInfiniteQuery(
    params: AdminEbayApiAdminEbayListingRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayListing,
            Array<runtime.ApiError>,
            AdminEbayListing,
            AdminEbayListing,
            ['adminEbayListing-infinite', AdminEbayApiAdminEbayListingRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayListingInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayListing({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayProductCategoryQueryOptions = UseQueryOptions<
    AdminEbayCategoryResp,
    Array<Error>,
    AdminEbayCategoryResp,
    ['adminEbayProductCategory', AdminEbayApiAdminEbayProductCategoryRequest]
>;

let useAdminEbayProductCategoryQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayProductCategoryRequest,
          options?: AdminEbayProductCategoryQueryOptions
      ) => AdminEbayProductCategoryQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayProductCategoryQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayProductCategoryRequest,
        options?: AdminEbayProductCategoryQueryOptions
    ) => AdminEbayProductCategoryQueryOptions | undefined
) {
    useAdminEbayProductCategoryQueryGlobalOptions = callback;
}

export function getAdminEbayProductCategoryQueryKey(
    params: AdminEbayApiAdminEbayProductCategoryRequest
): ['adminEbayProductCategory', AdminEbayApiAdminEbayProductCategoryRequest] {
    return ['adminEbayProductCategory', params];
}

export function useAdminEbayProductCategoryQuery(
    params: AdminEbayApiAdminEbayProductCategoryRequest,
    options?: AdminEbayProductCategoryQueryOptions
): UseQueryResult<AdminEbayCategoryResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayProductCategoryQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayProductCategory(params, {signal})
            ),
        {
            ...options,
            ...useAdminEbayProductCategoryQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayProductCategoryMutationOptions = UseMutationOptions<
    AdminEbayCategoryResp,
    Array<Error>,
    AdminEbayApiAdminEbayProductCategoryRequest
>;

let useAdminEbayProductCategoryMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayProductCategoryMutationOptions
      ) => AdminEbayProductCategoryMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayProductCategoryMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayProductCategoryMutationOptions
    ) => AdminEbayProductCategoryMutationOptions | undefined
) {
    useAdminEbayProductCategoryMutationGlobalOptions = callback;
}

export function useAdminEbayProductCategoryMutation(
    options?: AdminEbayProductCategoryMutationOptions
): UseMutationResult<AdminEbayCategoryResp, Array<runtime.ApiError>, AdminEbayApiAdminEbayProductCategoryRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayProductCategory(params)),
        {
            ...options,
            ...useAdminEbayProductCategoryMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayProductCategoryInfiniteQueryKey(
    params: AdminEbayApiAdminEbayProductCategoryRequest
): ['adminEbayProductCategory-infinite', AdminEbayApiAdminEbayProductCategoryRequest] {
    return ['adminEbayProductCategory-infinite', params];
}

export function useAdminEbayProductCategoryInfiniteQuery(
    params: AdminEbayApiAdminEbayProductCategoryRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayCategoryResp,
            Array<runtime.ApiError>,
            AdminEbayCategoryResp,
            AdminEbayCategoryResp,
            ['adminEbayProductCategory-infinite', AdminEbayApiAdminEbayProductCategoryRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayCategoryResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayProductCategoryInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayProductCategory({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayPublishQueryOptions = UseQueryOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayListing,
    ['adminEbayPublish', AdminEbayApiAdminEbayPublishRequest]
>;

let useAdminEbayPublishQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbayPublishRequest,
          options?: AdminEbayPublishQueryOptions
      ) => AdminEbayPublishQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayPublishQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbayPublishRequest,
        options?: AdminEbayPublishQueryOptions
    ) => AdminEbayPublishQueryOptions | undefined
) {
    useAdminEbayPublishQueryGlobalOptions = callback;
}

export function getAdminEbayPublishQueryKey(
    params: AdminEbayApiAdminEbayPublishRequest
): ['adminEbayPublish', AdminEbayApiAdminEbayPublishRequest] {
    return ['adminEbayPublish', params];
}

export function useAdminEbayPublishQuery(
    params: AdminEbayApiAdminEbayPublishRequest,
    options?: AdminEbayPublishQueryOptions
): UseQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayPublishQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayPublish(params, {signal})),
        {
            ...options,
            ...useAdminEbayPublishQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbayPublishMutationOptions = UseMutationOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayApiAdminEbayPublishRequest
>;

let useAdminEbayPublishMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayPublishMutationOptions
      ) => AdminEbayPublishMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayPublishMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayPublishMutationOptions
    ) => AdminEbayPublishMutationOptions | undefined
) {
    useAdminEbayPublishMutationGlobalOptions = callback;
}

export function useAdminEbayPublishMutation(
    options?: AdminEbayPublishMutationOptions
): UseMutationResult<AdminEbayListing, Array<runtime.ApiError>, AdminEbayApiAdminEbayPublishRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayPublish(params)),
        {
            ...options,
            ...useAdminEbayPublishMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayPublishInfiniteQueryKey(
    params: AdminEbayApiAdminEbayPublishRequest
): ['adminEbayPublish-infinite', AdminEbayApiAdminEbayPublishRequest] {
    return ['adminEbayPublish-infinite', params];
}

export function useAdminEbayPublishInfiniteQuery(
    params: AdminEbayApiAdminEbayPublishRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayListing,
            Array<runtime.ApiError>,
            AdminEbayListing,
            AdminEbayListing,
            ['adminEbayPublish-infinite', AdminEbayApiAdminEbayPublishRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayPublishInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbayPublish({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbaySaveDraftQueryOptions = UseQueryOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayListing,
    ['adminEbaySaveDraft', AdminEbayApiAdminEbaySaveDraftRequest]
>;

let useAdminEbaySaveDraftQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbaySaveDraftRequest,
          options?: AdminEbaySaveDraftQueryOptions
      ) => AdminEbaySaveDraftQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySaveDraftQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbaySaveDraftRequest,
        options?: AdminEbaySaveDraftQueryOptions
    ) => AdminEbaySaveDraftQueryOptions | undefined
) {
    useAdminEbaySaveDraftQueryGlobalOptions = callback;
}

export function getAdminEbaySaveDraftQueryKey(
    params: AdminEbayApiAdminEbaySaveDraftRequest
): ['adminEbaySaveDraft', AdminEbayApiAdminEbaySaveDraftRequest] {
    return ['adminEbaySaveDraft', params];
}

export function useAdminEbaySaveDraftQuery(
    params: AdminEbayApiAdminEbaySaveDraftRequest,
    options?: AdminEbaySaveDraftQueryOptions
): UseQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbaySaveDraftQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySaveDraft(params, {signal})),
        {
            ...options,
            ...useAdminEbaySaveDraftQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbaySaveDraftMutationOptions = UseMutationOptions<
    AdminEbayListing,
    Array<Error>,
    AdminEbayApiAdminEbaySaveDraftRequest
>;

let useAdminEbaySaveDraftMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbaySaveDraftMutationOptions
      ) => AdminEbaySaveDraftMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySaveDraftMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbaySaveDraftMutationOptions
    ) => AdminEbaySaveDraftMutationOptions | undefined
) {
    useAdminEbaySaveDraftMutationGlobalOptions = callback;
}

export function useAdminEbaySaveDraftMutation(
    options?: AdminEbaySaveDraftMutationOptions
): UseMutationResult<AdminEbayListing, Array<runtime.ApiError>, AdminEbayApiAdminEbaySaveDraftRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySaveDraft(params)),
        {
            ...options,
            ...useAdminEbaySaveDraftMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbaySaveDraftInfiniteQueryKey(
    params: AdminEbayApiAdminEbaySaveDraftRequest
): ['adminEbaySaveDraft-infinite', AdminEbayApiAdminEbaySaveDraftRequest] {
    return ['adminEbaySaveDraft-infinite', params];
}

export function useAdminEbaySaveDraftInfiniteQuery(
    params: AdminEbayApiAdminEbaySaveDraftRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayListing,
            Array<runtime.ApiError>,
            AdminEbayListing,
            AdminEbayListing,
            ['adminEbaySaveDraft-infinite', AdminEbayApiAdminEbaySaveDraftRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayListing, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbaySaveDraftInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbaySaveDraft({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbaySellingLimitQueryOptions = UseQueryOptions<
    AdminEbaySellingLimitResp,
    Array<Error>,
    AdminEbaySellingLimitResp,
    ['adminEbaySellingLimit']
>;

let useAdminEbaySellingLimitQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbaySellingLimitQueryOptions
      ) => AdminEbaySellingLimitQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySellingLimitQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbaySellingLimitQueryOptions
    ) => AdminEbaySellingLimitQueryOptions | undefined
) {
    useAdminEbaySellingLimitQueryGlobalOptions = callback;
}

export function getAdminEbaySellingLimitQueryKey(): ['adminEbaySellingLimit'] {
    return ['adminEbaySellingLimit'];
}

export function useAdminEbaySellingLimitQuery(
    options?: AdminEbaySellingLimitQueryOptions
): UseQueryResult<AdminEbaySellingLimitResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbaySellingLimitQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySellingLimit({signal})),
        {
            ...options,
            ...useAdminEbaySellingLimitQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminEbaySellingLimitMutationOptions = UseMutationOptions<AdminEbaySellingLimitResp, Array<Error>>;

let useAdminEbaySellingLimitMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbaySellingLimitMutationOptions
      ) => AdminEbaySellingLimitMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySellingLimitMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbaySellingLimitMutationOptions
    ) => AdminEbaySellingLimitMutationOptions | undefined
) {
    useAdminEbaySellingLimitMutationGlobalOptions = callback;
}

export function useAdminEbaySellingLimitMutation(
    options?: AdminEbaySellingLimitMutationOptions
): UseMutationResult<AdminEbaySellingLimitResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySellingLimit()),
        {
            ...options,
            ...useAdminEbaySellingLimitMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbaySellingLimitInfiniteQueryKey(): ['adminEbaySellingLimit-infinite'] {
    return ['adminEbaySellingLimit-infinite'];
}

export function useAdminEbaySellingLimitInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbaySellingLimitResp,
            Array<runtime.ApiError>,
            AdminEbaySellingLimitResp,
            AdminEbaySellingLimitResp,
            ['adminEbaySellingLimit-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbaySellingLimitResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbaySellingLimitInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySellingLimit()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbaySetupQueryOptions = UseQueryOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayAccountResp,
    ['adminEbaySetup', AdminEbayApiAdminEbaySetupRequest]
>;

let useAdminEbaySetupQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminEbayApiAdminEbaySetupRequest,
          options?: AdminEbaySetupQueryOptions
      ) => AdminEbaySetupQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySetupQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminEbayApiAdminEbaySetupRequest,
        options?: AdminEbaySetupQueryOptions
    ) => AdminEbaySetupQueryOptions | undefined
) {
    useAdminEbaySetupQueryGlobalOptions = callback;
}

export function getAdminEbaySetupQueryKey(
    params: AdminEbayApiAdminEbaySetupRequest
): ['adminEbaySetup', AdminEbayApiAdminEbaySetupRequest] {
    return ['adminEbaySetup', params];
}

export function useAdminEbaySetupQuery(
    params: AdminEbayApiAdminEbaySetupRequest,
    options?: AdminEbaySetupQueryOptions
): UseQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbaySetupQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySetup(params, {signal})),
        {
            ...options,
            ...useAdminEbaySetupQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminEbaySetupMutationOptions = UseMutationOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayApiAdminEbaySetupRequest
>;

let useAdminEbaySetupMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminEbaySetupMutationOptions) => AdminEbaySetupMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbaySetupMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbaySetupMutationOptions
    ) => AdminEbaySetupMutationOptions | undefined
) {
    useAdminEbaySetupMutationGlobalOptions = callback;
}

export function useAdminEbaySetupMutation(
    options?: AdminEbaySetupMutationOptions
): UseMutationResult<AdminEbayAccountResp, Array<runtime.ApiError>, AdminEbayApiAdminEbaySetupRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbaySetup(params)),
        {
            ...options,
            ...useAdminEbaySetupMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbaySetupInfiniteQueryKey(
    params: AdminEbayApiAdminEbaySetupRequest
): ['adminEbaySetup-infinite', AdminEbayApiAdminEbaySetupRequest] {
    return ['adminEbaySetup-infinite', params];
}

export function useAdminEbaySetupInfiniteQuery(
    params: AdminEbayApiAdminEbaySetupRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayAccountResp,
            Array<runtime.ApiError>,
            AdminEbayAccountResp,
            AdminEbayAccountResp,
            ['adminEbaySetup-infinite', AdminEbayApiAdminEbaySetupRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbaySetupInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminEbayApi().adminEbaySetup({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminEbayVerifyQueryOptions = UseQueryOptions<
    AdminEbayAccountResp,
    Array<Error>,
    AdminEbayAccountResp,
    ['adminEbayVerify']
>;

let useAdminEbayVerifyQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminEbayVerifyQueryOptions) => AdminEbayVerifyQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayVerifyQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayVerifyQueryOptions
    ) => AdminEbayVerifyQueryOptions | undefined
) {
    useAdminEbayVerifyQueryGlobalOptions = callback;
}

export function getAdminEbayVerifyQueryKey(): ['adminEbayVerify'] {
    return ['adminEbayVerify'];
}

export function useAdminEbayVerifyQuery(
    options?: AdminEbayVerifyQueryOptions
): UseQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminEbayVerifyQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayVerify({signal})),
        {
            ...options,
            ...useAdminEbayVerifyQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminEbayVerifyMutationOptions = UseMutationOptions<AdminEbayAccountResp, Array<Error>>;

let useAdminEbayVerifyMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminEbayVerifyMutationOptions
      ) => AdminEbayVerifyMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminEbayVerifyMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminEbayVerifyMutationOptions
    ) => AdminEbayVerifyMutationOptions | undefined
) {
    useAdminEbayVerifyMutationGlobalOptions = callback;
}

export function useAdminEbayVerifyMutation(
    options?: AdminEbayVerifyMutationOptions
): UseMutationResult<AdminEbayAccountResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayVerify()),
        {
            ...options,
            ...useAdminEbayVerifyMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminEbayVerifyInfiniteQueryKey(): ['adminEbayVerify-infinite'] {
    return ['adminEbayVerify-infinite'];
}

export function useAdminEbayVerifyInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminEbayAccountResp,
            Array<runtime.ApiError>,
            AdminEbayAccountResp,
            AdminEbayAccountResp,
            ['adminEbayVerify-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminEbayAccountResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminEbayVerifyInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminEbayApi().adminEbayVerify()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
